import { render, staticRenderFns } from "./ContractProfileCard.vue?vue&type=template&id=86a5b322&scoped=true"
import script from "./ContractProfileCard.vue?vue&type=script&lang=js"
export * from "./ContractProfileCard.vue?vue&type=script&lang=js"
import style0 from "./ContractProfileCard.vue?vue&type=style&index=0&id=86a5b322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a5b322",
  null
  
)

export default component.exports